import angular from 'angular';

angular
  .module('cloudX')
  .filter('relationName', ['$filter', 'dataCache', 'checkTenantConfiguration', relationName]);
angular.module('cloudX').filter('compactRelation', () => compactRelation);
angular
  .module('cloudX')
  .filter('relationNameCode', [
    '$filter',
    'dataCache',
    'checkTenantConfiguration',
    relationNameCode,
  ]);
angular.module('cloudX').filter('relationContactName', relationContactName);

const aliasFieldId = 'aeedc3e5-73cf-41c2-abb4-423d75d2f52b';

const getFieldValue = function(rel, fieldId, defaultValue) {
  if (!rel || !fieldId || !rel[fieldId]) return defaultValue;
  return rel[fieldId].value || defaultValue;
};
const getTitleCode = function(rel) {
  if (typeof rel === 'string') return null;
  if (rel.legalFormSalutationFieldId) return getFieldValue(rel, rel.legalFormSalutationFieldId, '');
  return rel.title;
};

function getNLSolePropAlias(rel, checkTenantConfiguration, titleCode) {
  if (!rel || !checkTenantConfiguration('5')) return null;
  if (rel.type !== 1) return null;
  if (!!rel.alias) return rel.alias;
  return getFieldValue(rel, aliasFieldId, null);
}

function relationNameCode($filter, dataCache, checkTenantConfiguration) {
  return function(rel, firstName, titleCode, ignoreAlias) {
    if (!rel) return '';

    // Use the existing relationName filter to get the base name
    var relationName = $filter('relationName')(rel, firstName, titleCode, ignoreAlias);

    // Append the UniqueIdentifier to the relation name
    if (!rel.customerCode) return relationName + ' | ' + rel.uniqueIdentifier;
    return relationName + ' | ' + rel.customerCode;
  };
}

function relationName($filter, dataCache, checkTenantConfiguration) {
  var getName = function(rel, firstName) {
    if (typeof rel === 'string')
      return (rel.infix ? rel.infix + ' ' : '') + rel + (firstName ? ' ' + firstName : '');
    if (rel.nameFieldId) {
      //PD
      if (rel.infixFieldId) {
        const firstName = getFieldValue(rel, rel.firstNameFieldId, '');
        return (
          getFieldValue(rel, rel.infixFieldId, '') +
          ' ' +
          getFieldValue(rel, rel.nameFieldId, '') +
          (rel.type === 0 ? '' : !!firstName ? ' ' + firstName : '')
        ).trim();
      } else {
        return (
          getFieldValue(rel, rel.nameFieldId, '') +
          (rel.type === 0 ? '' : !!firstName ? ' ' + firstName : '')
        ).trim();
      }
    }
    return (
      (rel.infix ? rel.infix + ' ' : '') +
      (rel.name || '') +
      (rel.firstName ? ' ' + rel.firstName : '')
    );
  };

  return function(rel, firstName, titleCode, ignoreAlias) {
    if (!rel) return '';
    var name = getName(rel, firstName);

    if (!titleCode && titleCode !== 0) titleCode = getTitleCode(rel);
    if (typeof titleCode === 'string') titleCode = parseInt(titleCode);
    if (!ignoreAlias) {
      const alias = getNLSolePropAlias(rel, checkTenantConfiguration, titleCode);
      if (!!alias) return alias;
    }

    if (!titleCode && titleCode !== 0) return name;
    var titles = dataCache.getObject(rel.type !== 0 ? 'salutation' : 'legalForm');
    if (!titles) return name; //Cache not ready

    var title = titles[titleCode];
    if (!title) return name;

    if (rel.type !== 0) {
      if (!title.show) return name;
      return (
        $filter('translateList')(titleCode, 'salutation', title.description || '') +
        ' ' +
        name
      ).trim();
    }
    if (!title.appendLegalFormToName) return name;
    return (
      name +
      ' ' +
      $filter('translateList')(titleCode, 'legalForm', title.description || '')
    ).trim();
  };
}

function relationContactName() {
  return function(relation) {
    if (!relation) return '';

    const name = relation.contactName || '';
    const infix = relation.contactInfix || '';
    const firstName = relation.contactFirstName || '';

    return ((infix ? infix + ' ' : '') + name + (firstName ? ' ' + firstName : '')).trim();
  };
}

// Converts relation file object (with guids as fields) to relation name object
const compactRelation = rel => {
  if (!rel || !rel.id) return null;
  var result = {
    id: rel.id,
    type: rel.type,
    crm: rel.crm,
    name: rel.name || null,
    infix: rel.infix || null,
    firstName: rel.firstName || null,
    title: rel.title || null,
    customerCode: rel.customerCode || null,
    uniqueIdentifier: rel.uniqueIdentifier || null,
    relationHandlingLevel: rel.relationHandlingLevel || null,
    relationHandlingLevelClarification: rel.relationHandlingLevelClarification || null,
  };
  if (rel.nameFieldId) {
    result.name = getFieldValue(rel, rel.nameFieldId, null);
  }
  if (rel.infixFieldId) {
    result.infix = getFieldValue(rel, rel.infixFieldId, null);
  }
  if (rel.firstNameFieldId) {
    result.firstName = getFieldValue(rel, rel.firstNameFieldId, null);
  }
  if (rel.legalFormSalutationFieldId) {
    result.title = parseInt(getFieldValue(rel, rel.legalFormSalutationFieldId, 0));
  }
  if (rel.codeFieldId) {
    result.customerCode = getFieldValue(rel, rel.codeFieldId, null);
  }
  if (rel.uniqueIdentifierFieldId) {
    result.uniqueIdentifier = getFieldValue(rel, rel.uniqueIdentifierFieldId, null);
  }
  return result;
};

export { compactRelation };
